import React from 'react';
import { useTranslation } from 'react-i18next';

const STATUS_COLORS: Record<string, string> = {
  active: '#22c55e',
  pending: '#f59e0b',
  archived: '#6b7280',
};

interface StatusBadgeProps {
  status: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  const color = STATUS_COLORS[status] ?? '#6b7280';
  return (
    <span
      style={{
        padding: 'var(--space-xs) var(--space-sm)',
        borderRadius: 'var(--radius-full)',
        backgroundColor: `${color}20`,
        color,
        fontSize: 'var(--font-xs)',
        fontWeight: 600,
        border: `1px solid ${color}50`,
        whiteSpace: 'nowrap',
      }}
    >
      {t(`status.${status}`, { defaultValue: status })}
    </span>
  );
};
